export type ExpectedToggles = (typeof EXPECTED_TOGGLES)[number]
export const EXPECTED_TOGGLES = ['disableMerOppfolgingRegistering'] as const
